<template>
  <div
    class="indoorviewer-menu-search-field"
    :class="{
      'indoorviewer-menu-search-field__split-view': isSplitIndoorViewer
    }"
  >
    <SearchField
      v-if="navvisInstanceURL"
      :searchRestURL="navvisInstanceURL"
      :inputMinLength="2"
      @searchResults="displaySearchResults"
    />
  </div>
</template>

<script>
import SearchField from '@/components/general/SearchField.vue'
import { INDOORVIEWER_PREFIX } from '@/store/module-prefixes'
import { mapGetters } from 'vuex'

export default {
  name: 'IndoorviewerMenuSearchField',
  components: {
    SearchField
  },
  emits: ['search'],
  computed: {
    ...mapGetters(INDOORVIEWER_PREFIX, {
      isSplitIndoorViewer: 'isSplitIndoorViewer',
      navvisInstanceURL: 'navvisInstanceURL'
    })
  },
  methods: {
    displaySearchResults(results) {
      this.$emit('search', results)
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';
.indoorviewer-menu-search-field {
  flex-grow: 1;
  position: absolute;
  left: 64px;
  top: 14px;
  border: none;
  -webkit-transition: width 0.4s ease-in;
  transition: width 0.4s ease-in;
  &__split-view {
    left: 54px;
    outline: none;
    &:focus-within {
      outline: 0;
    }
  }
  @media screen and (max-width: 1024px) {
    left: 128px;
    top: 16px;
  }
  @media screen and (max-width: 658px) {
    left: 118px;
    outline: none;
    &:focus-within {
      outline: 0;
    }
  }
}
</style>
